import i18n from 'i18next';
import {
  initReactI18next,
} from 'react-i18next';

import gymcloudEN from './locales/en/gymcloud.json';
import strongfirstEN from './locales/en/strongfirst.json';

const getVariationAOrAn = (value: string, capitalize: boolean) => {
  const letters = ['a', 'e', 'i', 'o', 'u', 'h'];
  const firstLetter = value.substring(0, 1);
  let correctWordForm = '';
  if (letters.find((l) => firstLetter === l)) {
    correctWordForm = capitalize ? 'An' : 'an';
  } else {
    correctWordForm = capitalize ? 'A' : 'a';
  }

  return correctWordForm;
};

const resources = {
  en: {
    gymcloud: gymcloudEN,
    strongfirst: strongfirstEN,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    ns: ['gymcloud', 'strongfirst'],
    defaultNS: 'gymcloud',
    lng: 'en',
    fallbackLng: 'en',
    fallbackNS: 'gymcloud',
    interpolation: {
      escapeValue: false,
      format(value, format, lng) {
        if (format === 'cap') return value.charAt(0).toUpperCase() + value.slice(1);
        if (format === 'en-handle-an') return (!lng || lng === 'en') ? getVariationAOrAn(value, false) : '';
        if (format === 'en-handle-an-capitalized') return (!lng || lng === 'en') ? getVariationAOrAn(value, true) : '';
        return value;
      },
    },

    keySeparator: false,
  }, (error) => {
    if (error) {
      console.error(error);
    }
  });

export default i18n;
